'use es6';

import { createContext } from 'react';
const EditorActionsAndEventsContext = /*#__PURE__*/createContext({});
export default EditorActionsAndEventsContext;